import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import AlarmOutlinedIcon from '@mui/icons-material/AlarmOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { NotificationCategory, NotificationLevel } from '@/api/notifications';

const ICONS: Record<NotificationCategory, React.ComponentType<SvgIconProps>> = {
  Workflow: AccountTreeOutlinedIcon,
  Escalation: PriorityHighOutlinedIcon,
  Reminder: AlarmOutlinedIcon,
  Report: DescriptionOutlinedIcon,
  Performance: TrackChangesOutlinedIcon,
  Initiative: RocketLaunchOutlinedIcon,
  Risk: GppMaybeOutlinedIcon,
  Milestone: FlagOutlinedIcon,
  Accounting: AccountBalanceOutlinedIcon,
  Stock: Inventory2OutlinedIcon,
  Hr: BadgeOutlinedIcon,
  Fleet: LocalShippingOutlinedIcon,
  Parking: LocalParkingOutlinedIcon,
  Learning: SchoolOutlinedIcon,
  System: InfoOutlinedIcon,
};

export function CategoryIcon({ category, level, fontSize = 'small' }: { category: NotificationCategory; level: NotificationLevel; fontSize?: SvgIconProps['fontSize'] }) {
  const Icon = ICONS[category] ?? InfoOutlinedIcon;
  return <Icon fontSize={fontSize} sx={{ color: levelColor(level) }} />;
}

export function levelColor(level: NotificationLevel): string {
  switch (level) {
    case 'Action': return '#C62828';
    case 'Warning': return '#EF6C00';
    case 'Success': return '#2E7D32';
    default: return '#1565C0';
  }
}

/** Compact relative time, e.g. "3m", "2h", "5d". */
export function timeAgo(iso: string): string {
  const secs = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  if (secs < 604800) return `${Math.floor(secs / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}
